import { Injectable } from '@angular/core';
import { ConstantsStore } from '../constants.store';
import { ApiService } from '../api-service';
import { UserBuyingsStore } from './user-buyings.store';
import { UserBuying } from '../../../models/acquista-servizi-models/user-buying';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TableObject } from 'src/app/models/tableObject';

@Injectable({
  providedIn: 'root',
})
export class UserBuyingsService {

  showedWarning = false;
  
  constructor(
    private store: UserBuyingsStore,
    private constants: ConstantsStore,
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  getNotExpiringBuyings(): Observable<any> {
    return new Observable((observer) => {
      this.apiGet('NotExpiring')
        .subscribe(
          (notExpiringBuyings) => {
            this.store.notExpiringUserBuyings = notExpiringBuyings;
            observer.next();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  getExpiringBuyings(): Observable<any> {
    return new Observable((observer) => {
      this.apiGet('Expiring')
        .subscribe(
          (expiringBuyings) => {
            this.store.expiringUserBuyings = expiringBuyings;
            observer.next();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  public getUserExpiringBuyingsPromise(): Promise<UserBuying[]> {
    return new Promise((resolve, reject) => {
      this.apiGet('Expiring')
        .toPromise()
        .then(
          (res) => resolve(res),
          (error: any) => reject(error)
        );
    });
  }

  getAllUserBuyings(guid: string): Observable<any> {
    return new Observable(observer => {
      this.apiGetUserBuyings(guid)
        .subscribe(
          data => observer.next(data),
          error => observer.error(error)
        );
    });
  }

  public getUserBuyings(guid: string): Promise<UserBuying[]> {
    return new Promise((resolve, reject) => {
      this.http.get<UserBuying[]>(`${this.constants.userBuyingsUrl}/${guid}`)
        .toPromise()
        .then(
          (buyings: UserBuying[]) => resolve(buyings),
          (error: any) => reject(error)
        );
    });
  }

  public getUsersIdByProduct(
    pageNumber: number,
    productId: number | null,
    status: number | null): Promise<TableObject<number>> {
    let queryParams = new HttpParams()
      .set('pageNumber', pageNumber.toString());
    
    // console.log('PRODUCT ID', productId);
    // console.log('STATUS', status);
    

    if (productId) { 
      // console.log('DEFINISCO Product Id param');
      queryParams = queryParams.append('productId', productId.toString());
    }
    if (status) { 
      // console.log('DEFINISCO Status param');
      queryParams = queryParams.append('status', status.toString()); 
    }

    // console.log('QUERY PARAMS', queryParams.toString());

    return new Promise((resolve, reject) => {
      this.http.get<TableObject<number>>(`${this.constants.userBuyingsUrl}/IdentitySearch`, { params: queryParams })
        .toPromise()
        .then(
          (usersId: TableObject<number>) => resolve(usersId),
          (error: any) => reject(error)
        );
    });
  }

  public updateUserBuyingDates(userBuying: UserBuying): Promise<UserBuying> {
    return new Promise((resolve, reject) => {
      this.apiPatchUserBuyingsDate(userBuying)
        .toPromise()
        .then(
          (buying: UserBuying) => resolve(buying),
          (error: any) => reject(error)
        );
    });
  }

  public deleteUserBuyingDates(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.apiDeleteUserBuyings(id)
        .toPromise()
        .then(
          (buying: boolean) => resolve(buying),
          (error: any) => reject(error)
        );
    });
  }

  atLeastOneExpiringBuyingExists() {
    return this.store.expiringUserBuyings.length > 0;
  }

  atLeastOneNotExpiringBuyingExists() {
    return this.store.notExpiringUserBuyings.length > 0;
  }


  private apiGet(subPath: string): Observable<UserBuying[]> {
    return this.apiService.get<UserBuying[]>(
      `${this.constants.userBuyingsUrl}/${subPath}`
    );
  }

  private apiGetUserBuyings(guid: string) {
    return this.apiService.get<UserBuying[]>(`${this.constants.userBuyingsUrl}/${guid}`);
  }

  private apiDeleteUserBuyings(id: number) {
    return this.http.delete<boolean>(`${this.constants.userBuyingsUrl}/${id}`);
  }

  public apiPatchUserBuyingsDate(userBuying: UserBuying) {
    return this.apiService.patch<UserBuying>(`${this.constants.userBuyingsUrl}`, userBuying);
  }
}
